import { makeStyles } from '@material-ui/core/styles';
import { IDangerTooltip } from "./IDangerToolTip";

const useStyles = makeStyles({
    previoustitle: { fontSize: "12px", fontFamily: "Source Sans Pro", fontWeight: 500 },
    previouscontent: { textDecoration: "line-through", color: "black", fontWeight: 500 },
    currenttitle: { fontSize: "12px", fontFamily: "Source Sans Pro", fontWeight: 500, marginTop: "1px", marginLeft: 3 },
    currentcontent: { color: "black", fontWeight: 500, marginLeft: 3, paddingBottom: 8 },
    borderbox: { 
        borderStyle: "solid", 
        borderWidth: "1.5px", 
        backgroundColor: "#ffff"
    },
    root:{
        wordBreak:"break-word"
    }
})

export const DangerToolTipContent = (props: IDangerTooltip) => {
    const classes = useStyles();
    return (<div className={classes.root}>
        <p className={classes.previoustitle}>{props.previoustitle}</p>
        { props.previousnote ? <p className={classes.previouscontent}>{props.previousnote}</p> : <></>}
        {props.previousdisclaimer ? <p className={classes.previouscontent}>{props.previousdisclaimer}</p> : <></>}
        {props.previouscontent ? <p className={classes.previouscontent}>{props.previouscontent}</p> : <></>}
        <div className={classes.borderbox}>
            <p className={classes.currenttitle}>{props.currenttitle}</p>
            {props.currentnote ? <p className={classes.currentcontent}>{props.currentnote}</p> : <></>}
            {props.currentdisclaimer ? <p className={classes.currentcontent}>{props.currentdisclaimer}</p> : <></>}
            {props.currentcontent ? <div className={classes.currentcontent}>{props.currentcontent}</div> : <></>}
        </div>
    </div>
    );
}
